import queryString from 'query-string'
import { TransactionsFiltersBody } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import { ExtendCurrency } from 'src/enums'
import { transactionsQueryKeys } from 'src/queries/queries.constants'
import {
  ExtendBaseQueryOptions,
  useExtendQuery,
} from 'src/queries/queries.utils'

interface AccountingStatistics {
  usdTotalCardSpendCents?: number
  cadTotalCardSpendCents?: number
  currencies: ExtendCurrency[]
  pendingManagerReview: number
  pendingFinalApproval: number
  missingReceipts: number
  missingCategories: number
  notSyncedToErp: number
}

export interface GetAccountingStatisticsRequest extends ExtendBaseQueryOptions {
  filters?: Partial<TransactionsFiltersBody>
}

export interface PeopleManagerDirectReportsResponse {
  statisticsData: AccountingStatistics
}

export const useQueryAccountingStatistics = ({
  filters,
}: GetAccountingStatisticsRequest) => {
  return useExtendQuery({
    queryKey: transactionsQueryKeys.accountingStatistics(filters),
    queryUrl: () =>
      `reports/transactions/v2/accounting/stats?${queryString.stringify({ ...filters })}`,
    select: (data: PeopleManagerDirectReportsResponse): AccountingStatistics =>
      data.statisticsData,
  })
}
